import userAgentMixin from '@/mixins/userAgent';

export default {
  mixins: [userAgentMixin],
  props: {
    modelValue: {
      type: [String, Number],
      default: '',
    },
    depositAmounts: {
      type: Array,
      default: () => [10, 25, 50],
    },
    hasError: {
      type: Boolean,
      default: false,
    },
    errorMessage: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['input', 'blur', 'add', 'update:modelValue'],
  computed: {
    formattedValue() {
      if (!this.modelValue && this.modelValue !== 0) return '';
      const str = String(this.modelValue);
      const dotIndex = str.indexOf('.');
      const intPart = (dotIndex >= 0 ? str.slice(0, dotIndex) : str).replace(/\D/g, '');
      const decPart = dotIndex >= 0 ? str.slice(dotIndex) : '';
      const formatted = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return formatted + decPart;
    },
  },
  methods: {
    handleInput(event) {
      const raw = event.target.value;
      const parts = raw.split('.');
      const intDigits = parts[0].replace(/\D/g, '').slice(0, 9);
      const decDigits = parts.length > 1 ? parts[1].replace(/\D/g, '').slice(0, 2) : null;
      const intFormatted = intDigits.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      const displayValue = decDigits !== null ? `${intFormatted}.${decDigits}` : intFormatted;
      const emitValue = decDigits !== null ? `${intDigits}.${decDigits}` : intDigits;
      event.target.value = displayValue;
      this.$emit('input', emitValue);
      this.$emit('update:modelValue', emitValue);
    },
  },
  mounted() {
    this.$nextTick(() => {
      if (!this.isWrapperApp && this.$refs.input) {
        this.$refs.input.focus();
      }
    });
  },
};
